export default __webpack_public_path__ + "ac6096a0c0c2c839b5927a4cf39af377.svg";